import { createSelector } from '@reduxjs/toolkit';
import { userSelector } from './userSelector';

export const selectIsUserAuthenticated = createSelector(userSelector, user => Boolean(user.isAuthenticated));
